import { Box, Divider, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { useTheme } from '@emotion/react'

const Title = ({ variant = 'h4', isHr, isShadow = true, title, description, secColor = 'secondary.text', color = 'primary.main', align = 'center', sx, onClick, className, fontWeight = 700, sxTitle, descriptionWidth = '55%' }) => {
    const themeM = useTheme();
    const isMobile = useMediaQuery(themeM.breakpoints.down('sm'));
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: align, gap: 2, my: 1, ...sx }}
                onClick={onClick}>
                <Box>
                    <Typography variant={isMobile ? 'h6' : variant} fontWeight={600}
                        color={color}
                        sx={{ textShadow: isShadow && "0px 0px 8px rgba(77, 76, 76, 0.25)", fontWeight: { md: fontWeight, xs: 'bold' }, fontSize: { md: '40px', xs: '30px' }, lineHeight: '75px', ...sxTitle }}
                        className={className}>{title}</Typography>
                    {isHr && <Divider sx={{ borderColor: 'secondary.main', mt: 1 }} />}
                </Box>
                {description && description?.split('.')?.map((part, index) => (
                    <Typography key={index} color={secColor} sx={{ textAlign: 'center', fontSize: '25px', lineHeight: '45px', fontWeight: 400, width: { md: descriptionWidth, xs: '100%' }, m: 'auto' }} variant={isMobile ? 'body1' : 'body1'} >{part}</Typography>
                ))}
            </Box>
        </>
    )
}

export default Title